export default "__VITE_ASSET__Chlg7Il8__"